import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import classNames from "classnames";

import styles from "./ScrollToBottomButton.module.css";

interface ScrollToBottomButtonProps {
  /** Whether to show the button */
  show: boolean;

  /** Callback when button is clicked */
  onClick: () => void;

  /** Whether the button is in a loading state */
  loading: boolean;
}

/**
 * A floating button that appears when the user has scrolled up
 * from the bottom of content. Clicking it scrolls back to the bottom.
 */
export function ScrollToBottomButton({
  show,
  onClick,
  loading,
}: ScrollToBottomButtonProps) {
  if (!show) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      className={classNames(styles.button, {
        [styles.animationContainer]: loading,
        [styles.border]: !loading,
      })}
      aria-label="Scroll to bottom"
    >
      Scroll to bottom
      <KeyboardArrowDownIcon className={styles.icon} />
    </button>
  );
}
